var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CLEAR_DATA, EQUITY_HOLDING_LIVE_NEWS, LIVE_NEWS, LIVE_NEWS_ERROR, LIVE_NEWS_HIDE_ERROR, LIVE_NEWS_START_LOADER, LIVE_NEWS_STOP_LOADER, LIVE_NEWS_STREAM, QOUTE_STREAM_NEWS, RESET_STREAM_COUNT, } from "../interface/iLiveNewsReducer";
import { updateNewsQouteStream } from "@domains/utils/liveNewsStream";
var initialState = {
    liveNewsData: {
        content: [],
        number: 0,
        size: 0,
        totalElements: 0,
        totalPages: 0,
    },
    equityHoldingliveNewsData: {
        content: [],
        number: 0,
        size: 0,
        totalElements: 0,
        totalPages: 0,
    },
    liveNewsLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    streamCount: 0,
};
var liveNewsReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case LIVE_NEWS: {
            return __assign(__assign({}, state), { liveNewsData: action.payload.data });
        }
        case EQUITY_HOLDING_LIVE_NEWS: {
            return __assign(__assign({}, state), { equityHoldingliveNewsData: action.payload.data });
        }
        case QOUTE_STREAM_NEWS:
            return __assign(__assign({}, state), { liveNewsData: __assign(__assign({}, state.liveNewsData), { content: updateNewsQouteStream(state.liveNewsData.content, action.payload.qouteStream) }) });
        case LIVE_NEWS_STREAM:
            return __assign(__assign({}, state), { liveNewsData: __assign(__assign({}, state.liveNewsData), { content: __spreadArray([action.payload.liveNewsData], __read(state.liveNewsData.content), false) }), streamCount: state.streamCount + 1 });
        case RESET_STREAM_COUNT:
            return __assign(__assign({}, state), { streamCount: initialState.streamCount });
        case LIVE_NEWS_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case LIVE_NEWS_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initialState.errorData });
        case LIVE_NEWS_START_LOADER:
            return __assign(__assign({}, state), { liveNewsLoader: true });
        case LIVE_NEWS_STOP_LOADER:
            return __assign(__assign({}, state), { liveNewsLoader: false });
        case CLEAR_DATA:
            return initialState;
        default:
            return __assign({}, state);
    }
};
export default liveNewsReducer;
